import request from "@/api/request"
import auth from "@/utils/auth"
import utils from "@/utils/utils"
import qs from 'qs';
export default{
	baseUrl(){
		return request.baseUrl()
	},
	webUrl(){
		return request.webUrl();
	},
	/**
	 * 登录接口
	 */
	login(userName,passWord,code,codeToken){
		
		return request.post('/login',{
			userName:userName,
			passWord:passWord,
			captcha:code,
			captchaToken:codeToken
		})
		
	},
	/**
	 * 获取验证码
	 */
	getCaptcha(){
		return request.get('/captcha',{})
	},
	/**
	 * 记载用户信息
	 */
	loadUserInfo(){
		return request.post('/loadUserInfo',{})
	},
	/**
	 * 加载权限信息
	 */
	loadMenuInfo(){
		return request.post('/loadMenuInfo',{})
	},
	/**
	 * 管理员导航
	 */
	getMgtNav(){
		
		var list = [
			{id:1,title:"资源库",perms:"common:myfile:view",path:"/mgt/myfile",icon:require('../assets/images/icon_myfile.png'),current:false,children:null},
			{
				id:2,title:"我的",perms:"common:mine:view",path:"/mgt/mine",icon:require('../assets/images/icon_mine.png'),current:false,
				children:[
					{id:1,title:"我的收藏",perms:"common:mine:collect:view",path:"/mgt/mine/collect",icon:"",current:false},
					{id:2,title:"回收站",perms:"common:mine:recycle:view",path:"/mgt/mine/recycle",icon:"",current:false},
					{id:3,title:"我的分享",perms:"common:mine:share:view",path:"/mgt/mine/share",icon:"",current:false},
					{id:4,title:"我的下载",perms:"common:mine:download:view",path:"/mgt/mine/down",icon:"",current:false},
					{id:5,title:"修改密码",perms:"common:mine:changepwd",path:"/mgt/mine/changepwd",icon:"",current:false},
				]
			},
			{
				id:3,title:"团队",perms:"system:team:view",path:"/mgt/team",icon:require('../assets/images/icon_team.png'),current:false,
				children:[
					{id:1,title:"用户管理",perms:"system:user:view",path:"/mgt/team/user",icon:"",current:false},
					{id:2,title:"角色管理",perms:"system:role:view",path:"/mgt/team/role",icon:"",current:false},
					{id:3,title:"权限管理",perms:"system:perms:view",path:"/mgt/team/perms",icon:"",current:false},
					{id:4,title:"部门管理",perms:"system:dept:view",path:"/mgt/team/dept",icon:"",current:false}
				]
			},
			{
				id:4,title:"设置",perms:"system:options:view",path:"/mgt/options",icon:require('../assets/images/icon_options.png'),current:false,
				children:[
					{id:1,title:"系统配置",perms:"system:config:view",path:"/mgt/options/config",icon:"",current:false},
					{id:2,title:"行业管理",perms:"common:classify:view",path:"/mgt/options/classify",icon:"",current:false},
					{id:3,title:"标签管理",perms:"common:tag:view",path:"/mgt/options/tag",icon:"",current:false},
					{id:4,title:"来源管理",perms:"common:origin:view",path:"/mgt/options/origin",icon:"",current:false},
				]
			},
			{id:5,title:"统计",perms:"system:count:view",path:"/mgt/census",icon:require('../assets/images/icon_census.png'),current:false,children:null},
			{id:6,title:"日志",perms:"system:log:view",path:"/mgt/log",icon:require('../assets/images/icon_log.png'),current:false,children:null},
		]
		
		list.forEach((item)=>{
			if(item.children){
				try{
					item.children.forEach((item2)=>{
						if(auth.checkPerms(item2.perms)){
							item.path = item2.path
							
							throw Error()
						}
					})
				}catch(e){
					//TODO handle the exception
				}
				
			}
		})
		
		
		return list;
	},
	

	/**
	 * 上传文件
	 */
	upload(user_id,name,file){
		
		var formData = new FormData();
		formData.append("creatorId", user_id);
		formData.append("name", name);
		formData.append("file", file.file);
		return request.upload("/product/addProductTemp",formData)
		
	},
	
	/**
	 * 确认上传文件
	 */
	addProduct(classifyId,_data){
		// /product/addProduct
		// {
		// id:"ea90fcca-ff38-4eea-b3ec-f6681fd4276a",
		// title:"pro_img.5dcb739a.jpg",
		// size:"67.8",
		// file_url: "/image/temp/ea90fcca-ff38-4eea-b3ec-f6681fd4276a-list.jpg",
		// ext:"jpg",
		// is_select:false,
		// tags:["测试","汽车","跑车"],
		// source:0,"productDim":"1","productWt":"1"}}
		
		var data =[];
		
		_data.forEach((item,index)=>{
			var tags= "";
			if(item.tags.length>0){
				tags = item.tags.join(",");
			}
			var _item = {
				'name':item.title,
				'url':item.id,
				'type':item.ext,
				'material':item.material,
				'price':item.price,
				'color':item.color,
				'tagNames':tags,
				'origin':item.source+"",
				'productNum':item.productNum+"",
				'proSv':item.proSv+"",
				'productDim':item.productDim+"",
				'productWt':item.productWt+"",
				'stock':item.stock
			}
			
			data.push(_item);
			
		})
		data = JSON.stringify(data);
		
		return request.post("/product/addProduct",{
			'classifyId':classifyId,
			'data':data}
		)
		
	},

		/**
	 * 上传文件
	 */
	uploadTemp(user_id,name,file){
		
		var formData = new FormData();
		formData.append("creatorId", user_id);
		formData.append("name", name);
		formData.append("file", file.file);
		return request.upload("/product/addProductTemp2",formData)
		
	},
	/**
	 * 下载临时excel
	 */
	downExcelTemp(_data,size){
		// /product/addProduct
		// {
		// id:"ea90fcca-ff38-4eea-b3ec-f6681fd4276a",
		// title:"pro_img.5dcb739a.jpg",
		// size:"67.8",
		// file_url: "/image/temp/ea90fcca-ff38-4eea-b3ec-f6681fd4276a-list.jpg",
		// ext:"jpg",
		// is_select:false,
		// tags:["测试","汽车","跑车"],
		// source:0,"productDim":"1","productWt":"1"}}
		
		var data =[];
		
		_data.forEach((item,index)=>{
			var tags= "";
			if(item.tags.length>0){
				tags = item.tags.join(",");
			}
			var _item = {
				'name':item.title,
				'url':item.id,
				'type':item.ext,
				'material':item.material,
				'price':item.price,
				'color':item.color,
				'tagNames':tags,
				'origin':item.source+"",
				'productNum':item.productNum+"",
				'proSv':item.proSv+"",
				'productDim':item.productDim+"",
				'productWt':item.productWt+"",
				'stock':item.stock
			}
			
			data.push(_item);
			
		})
		data = JSON.stringify(data);
		
		return request.post("/product/downExcelTemp",{
			'size':size,
			'data':data}
		)
		
	},
	/**
	 * 下载临时pdf
	 */
	downPdfTemp(_data,num=1,water=1,title=1){
		// /product/addProduct
		// {
		// id:"ea90fcca-ff38-4eea-b3ec-f6681fd4276a",
		// title:"pro_img.5dcb739a.jpg",
		// size:"67.8",
		// file_url: "/image/temp/ea90fcca-ff38-4eea-b3ec-f6681fd4276a-list.jpg",
		// ext:"jpg",
		// is_select:false,
		// tags:["测试","汽车","跑车"],
		// source:0,"productDim":"1","productWt":"1"}}
		
		var data =[];
		
		_data.forEach((item,index)=>{
			var tags= "";
			if(item.tags.length>0){
				tags = item.tags.join(",");
			}
			var _item = {
				'name':item.title,
				'url':item.id,
				'type':item.ext,
				'material':item.material,
				'price':item.price,
				'color':item.color,
				'tagNames':tags,
				'origin':item.source+"",
				'productNum':item.productNum+"",
				'proSv':item.proSv+"",
				'productDim':item.productDim+"",
				'productWt':item.productWt+"",
				'stock':item.stock
			}
			
			data.push(_item);
			
		})
		data = JSON.stringify(data);
		
		return request.post("/product/downPdfTemp",{
			'num':num,
			'water':water,
			'title':title,
			'data':data}
		)
		
	},

	/**
	 * 修改产品
	 */
	updatePro(data){
		var formData = new FormData();
		formData.append("id", data.id);
		formData.append("classifyId", data.classifyId);
		formData.append("name", data.name);
		formData.append("material", data.material);
		formData.append("origin", data.origin);
		formData.append("price", data.price);
		formData.append("color", data.color);
		formData.append("file", data.file);
		formData.append("tagNames",data.tagNames);
		formData.append("remarks", data.remarks);
		formData.append("productNum", data.productNum);
		formData.append("proSv", data.proSv);
		formData.append('productDim',data.productDim);
		formData.append('productWt',data.productWt);
		formData.append('stock',data.stock);
		
		return request.upload("/product/updateProduct",formData)
	},
	//批量修改产品
	multiUpdatePro(data){
		var formData = new FormData();
		formData.append("ids",data.ids);
		formData.append("originId",data.originId);
		formData.append("classifyId",data.classifyId);
		formData.append("tagNames",data.tagNames);
		return request.upload("/product/updateBatchProduct",formData)
		
	},
	//批量移动产品
	multiUpdateMove(data){
		//{ids:'1,2,3,4,5,6,7',classifyId:1}
		return request.post("/product/updateBatchProductClassify",data)
	},
	
	//批量修改产品标签 cover 1 覆盖 0 不覆盖
	multiUpdateTag(data){
		
		//[{"tagName": "织极特常知","productId": "027557f056924425b5c5311a06885668"},{"tagName": "织极特常知","productId": "029d3792df7344c8962e9fd9c8fd2611"},{"tagName": "本团号记","productId": "06b5d185f8d947fcbf8c7f6d629cb010"}]
		return request.post("/product/addTagBatch",data)
	},
	
	//批量修改产品尺寸
	multiUpdateDim(data){
		return request.post("/product/setProductDimBatch",data);
	},
	//批量修改产品价格
	multiUpdatePrice(data){
		return request.post("/product/setProductPriceBatch",data);
	},
	//批量修改产品价格
	multiUpdateMaterial(data){
		return request.post("/product/setProductMaterialBatch",data);
	},
	//批量修改产品库存
	multiUpdateStock(data){
		return request.post("/product/setProductStockBatch",data);
	},
	
	//批量修改产品来源
	multiUpdateSource(data){
		//[{"originName": "织极特常知","productId": "027557f056924425b5c5311a06885668","classifyId":"1"}]
		return request.post("/product/addOriginBatch",data)
	},
	
	
	/**
	 * 获取分页 全条件
	 */
	getProPageList(data){
		
		return request.post('/product/selProductPage',data)
		// {
		// 	page:page,
		// 	limit:limit,
		// 	name:name,
		// 	classifyIds:classifyIds,
		// 	tagNames:tagNames,
		// 	type:types,
		// 	delFlag:delFlag,
		// 	orderBy:orderBy,
		// 	origin:sources,
		// 	material:"",
		//  selUUID:"",
		//  imageLabels:""
		// }
	},
	
	myProductsList(data){
		return request.post('/product/myProducts',data)
		// {
		// 	page:page,
		// 	limit:limit,
		// 	name:name,
		// 	material:"",
		// 	tagNames:tagNames,
		// 	type:type,
		// 	classifyIds:classifyIds,
		// 	delFlag:delFlag,
		// 	orderBy:orderBy,
		// 	origin:origin,
		// 	item:item
		// }
	},
	
	/**
	 * 回收产品 1放入 0恢复
	 */
	recyclePro(ids,type=1){
		return request.post('/product/recycleProduct',{
			ids:ids,
			type:type
		})
	},
	/**
	 * 收藏产品 0收藏 1取消
	 */
	collectionPro(ids){
		return request.post('/product/collection',{
			ids:ids
		})
	},
	/**
	 * 收藏产品 0收藏 1取消
	 */
	collectionPro2(ids,type){
		return request.post('/product/collection',{
			ids:ids,
			type:type
		})
	},
	/**
	 * @param {Object} ids id集合
	 */
	realDeletePro(ids){
		return request.post('/product/realDelete',{
			ids:ids
		})
	},
	/**
	 * 分享产品
	 * @param {Object} share
	 */
	sharePro(ids){
		return request.post('/product/share',{
			ids:ids
		})
	},
	getShare(share){
		return request.post('/product/getShareFile',{
			share:share
		})
	},
	/**
	 * 导出Excel
	 * @param {Object} ids
	 */
	downloadExcel(ids,size=10){
		return request.post('/down/downloadExcel',{
			ids:ids,
			size:size
		})
	},
	/**
	 * 导出Excel
	 * @param {Object} data
	 */
	myProductsAllDownloadExcel(data){
		return request.post('/down/myProductsAllDownloadExcel',data)
	},
	/**
	 * 导出Excel
	 * @param {Object} ids
	 */
	downloadPDF(ids,num=1,water=1){
		return request.post('/down/downloadPDF',{
			ids:ids,
			num:num,
			water:water
		})
	},
	/**
	 * 导出Excel
	 * @param {Object} ids
	 * @param {Object} type 0原图 1缩略图
	 */
	downloadImage(ids,type=0){
		return request.post('/down/downloadImage',{
			ids:ids,
			type:type
		})
	},
	
	
	getTypeList(){
		return [
			{label:"PNG",value:"PNG",is_check:false},
			{label:"JPG",value:"JPG",is_check:false},
			{label:"RAW",value:"RAW",is_check:false},
			{label:"GIF",value:"GIF",is_check:false},
		];
	},
	
	
	
	/**
	 * 我的文件
	 */
	getMyFile(type=1){
		return request.post('/product/myProducts',{type:type});
	},
	
	
	/**
	 * 添加行业
	 */
	addClassify(name,parentId=0,remarks,orderNum){
		
		return request.post('/classify/addClassify',{
			name:name,
			parentId:parentId,
			remarks:remarks,
			orderNum:orderNum
		})
		
	},
	/**
	 * 更新行业
	 */
	updateClassify(id,name,parentId=0,remarks,orderNum){
		return request.post('/classify/updateClassify',{
			id:id,
			name:name,
			parentId:parentId,
			remarks:remarks,
			orderNum:orderNum
		})
	},
	/**
	 * 获取行业列表
	 */
	selClassifyList(){
		var new_list = []; 
		request.post('/classify/selClassifyTree',{}).then(res=>{
			
			if(res.code==0){
				
				var list = res.list;
				list.forEach((item,index)=>{
					
					var children = [];
					item.children.forEach(child=>{
						children.push({
							value:  parseInt(child.classifyId),
							label: child.classifyName,
							is_check:false
						})
					})
					var newItem = {
						value:  parseInt(item.classifyId),
						label: item.classifyName,
						is_check:false
					}
					
					if(children.length>0){
						newItem.children = utils.getChilrenTree([],item.children);
					}
					
					new_list.push(newItem)
					
				})
				
			}
			
		}).catch(_=>{
			
		})
		
		return new_list;
		
	},
	/**
	 * 获取所有行业列表
	 */
	selClassifyList2(){
		var new_list = []; 
		request.post('/classify/selAllTree',{}).then(res=>{
			
			if(res.code==0){
				
				var list = res.list;
				list.forEach((item,index)=>{
					var children = [];
					item.children.forEach(child=>{
						children.push({
							value:  parseInt(child.classifyId),
							label: child.classifyName,
							is_check:false
						})
					})
					var newItem = {
						value:  parseInt(item.classifyId),
						label: item.classifyName,
						is_check:false
					}
					
					if(children.length>0){
						newItem.children = utils.getChilrenTree([],item.children);
					}
					
					new_list.push(newItem)
				})
			}
			
		}).catch(_=>{
			
		})
		
		return new_list;
		
	},
	selClassifyAllList(){
		var new_list = []; 
		request.post('/classify/selAllTree',{}).then(res=>{
			
			if(res.code==0){
				var list = res.list;
				list.forEach((item,index)=>{
					new_list.push(item)
				})
			}
			
		}).catch(_=>{
			
		})
		
		return new_list;
		
	},
	/**
	 * 删除行业
	 */
	delClassify(ids){
		return request.post('/classify/delClassify',{
			ids:ids
		})
	},
	
	/**
	 * 添加标签
	 */
	addTag(name,classifyId=0,orderNum=1){
		return request.post('/tag/addTag',{name:name,classifyId:classifyId,orderNum:orderNum})
	},
	/**
	 * 删除标签
	 */
	delTag(ids){
		return request.post('/tag/delTag',{ids:ids})
	},
	/**
	 * 修改标签
	 */
	updateTag(id,name,classifyId=0,orderNum=1){
		return request.post('/tag/updateTag',{id:id,name:name,classifyId:classifyId,orderNum:orderNum})
	},
	
	/**
	 * 获取标签列表
	 * @param {Object} 时间
	 */
	selTagList(name = "",idStr="", ){
		var tag_list = [];
		request.post('/tag/selTagList',{idStr:idStr,name:name}).then(res=>{
			if(res.code == 0){
				var list = res.tagList;
				//tag_list = res.tagList;
				list.forEach((item,index)=>{
					tag_list.push(item)
				})
			}
		})
		return tag_list;
	},
	
	/**
	 * 获取标签列表
	 * @param {Object} 时间
	 */
	getTagList(name = "",idStr="" ){
		var tag_list = [];
		request.post('/tag/selTagListFit',{idStr:idStr,name:name}).then(res=>{
			if(res.code == 0){
				var list = res.tagList;
				list.forEach((item,index)=>{
					tag_list.push({
						value:  item.tagId+"",
						label: item.tagName,
						is_check:false
					})
				})
				
			}
		})
		return tag_list;
	},
	getTagList2(name = "",idStr="" ){
		var tag_list = [];
		return new Promise((resolve,reject)=>{
			request.post('/tag/selTagListFit',{idStr:idStr,name:name}).then(res=>{
				if(res.code == 0){
					var list = res.tagList;
					list.forEach((item,index)=>{
						tag_list.push({
							value:  item.tagId+"",
							label: item.tagName,
							is_check:false
						})
					})
					resolve(tag_list);
				}else{
					resolve([]);
				}
			})
		})
	},
	
	addOrigin(name,classifyId=0,orderNum=1){
		return request.post('/origin/addOrigin',{name:name,classifyId:classifyId,orderNum:orderNum})
	},
	deleteOrigin(ids){
		return request.post('/origin/delOrigin',{ids:ids})
	},
	selAllOrigin(name){
		return request.post('/origin/selAllOrigin',{name:name})
	},
	selAllOriginFit(idStr){
		return request.post('/origin/selAllOriginFit',{idStr:idStr})
	},
	/**
	 * 获取来源列表
	 */
	getSourceList(name=""){
		
		
		return new Promise((resolve,reject)=>{
			var source = [];
			this.selAllOrigin(name).then(res=>{
				if(res.code==0){
					
					var list = res.list;
					list.forEach(item=>{
						source.push({
							value:item.originId,
							label:item.originName,
							is_check:false
						})
					})
					return resolve(source)
					
				}else{
					return resolve([])
				}
			}).catch(res=>{
				return resolve([])
			})
		})
		
	},
	
	/**
	 * 获取来源列表
	 */
	getSourceList2(idStr=""){
		
		return new Promise((resolve,reject)=>{
			var source = [];
			this.selAllOriginFit(idStr).then(res=>{
				if(res.code==0){
					
					var list = res.list;
					list.forEach(item=>{
						source.push({
							value:item.originId,
							label:item.originName,
							is_check:false
						})
					})
					return resolve(source)
					
				}else{
					return resolve([])
				}
			}).catch(res=>{
				return resolve([])
			})
		})
		
	},
	
	
	selOriginById(id){
		return request.post('/origin/selOriginById',{id:id})
	},
	updateOrigin(id,name,classifyId=0,orderNum=1){
		return request.post('/origin/updateOrigin',{id:id,name:name,classifyId:classifyId,orderNum:orderNum})
	},
	/**
	 * 查询日志枫叶
	 * @param {Object} type 操作类型
	 * @param {Object} selContent 操作内容或者用户名，模糊查询
	 * @param {Object} page 分页
	 * @param {Object} limit 分页数
	 * @param {Object} beginTime 开始时间
	 * @param {Object} endTime 结束时间
	 */
	selLogs(page,limit,type,selContent,beginTime,endTime){
		return request.post('/syslog/logs',{
			page:page,
			limit:limit,
			type:type,
			selContent:selContent,
			beginTime:beginTime,
			endTime:endTime
		})
	},
	/**
	 * 删除日志
	 * @param {Object} ids 集合
	 */
	deleteLogs(ids){
		return request.post('/syslog/delete',{ids:ids})
	},
	/**
	 * 清空日志
	 */
	cleanLogs(){
		return request.post('/syslog/clean',{})
	},
	/**
	 * 查看用户列表
	 * @param {Object} SearchValue 搜索
	 * @param {Object} page 分页
	 * @param {Object} limit 限制
	 */
	selUserList(SearchValue,page,limit){
		return request.post('/team/sysUser/selUserList',{
			SearchValue:SearchValue,
			page:page,
			limit:limit
		})
	},
	
	/**
	 * 添加用户
	 * @param {Object} userName 用户名
	 * @param {Object} trueName 正式姓名
	 * @param {Object} phone 手机号
	 * @param {Object} remarks 介绍
	 * @param {Object} roleIds 权限id集合
	 * @param {Object} file 文件对象-头像
	 */
	addUser(userName,trueName,phone,remarks,roleIds,classifyId,deptIds,file){
		var formData = new FormData();
		formData.append("userName", userName);
		formData.append("trueName", trueName);
		formData.append("phone", phone);
		formData.append("remarks", remarks);
		formData.append("roleIds", roleIds);
		formData.append("classifyId", classifyId);
		formData.append("deptIds", deptIds);
		formData.append("file", file);
		return request.upload('/team/sysUser/addUser',formData)
	},
	/**
	 * 修改用户
	 * @param {Object} id
	 * @param {Object} userName 用户名
	 * @param {Object} trueName 正式姓名
	 * @param {Object} phone 手机号
	 * @param {Object} remarks 介绍
	 * @param {Object} roleIds 权限id集合
	 * @param {Object} file 文件对象-头像
	 */
	updateUser(id,userName,trueName,phone,remarks,roleIds,classifyId,deptIds,file){
		var formData = new FormData();		
		formData.append("id", id);
		formData.append("userName", userName);
		formData.append("trueName", trueName);
		formData.append("phone", phone);
		formData.append("remarks", remarks);
		formData.append("roleIds", roleIds);
		formData.append("classifyId", classifyId);
		formData.append("deptIds", deptIds);
		formData.append("file", file);
		return request.upload('/team/sysUser/updateUser',formData)
	},
	
	/**
	 * 删除用户
	 * @param {Object} userIds 用户id集合
	 */
	delUser(userIds){
		return request.post('/team/sysUser/delUser',{userIds:userIds})
	},
	/**
	 * 用户修改自己密码
	 * @param {Object} data
	 */
	changeUserPwd(data){
		return request.post('/team/sysUser/setMinePwd',data)
	},
	/**
	 * 列表修改密码
	 * @param {Object} data
	 */
	changeUserPwdList(data){
		return request.post('/team/sysUser/setPwd',data)
	},
	
	/**
	 * 根据id获取用户
	 * @param {Object} id id
	 */
	getUserById(id){
		return request.post('/team/sysUser/getById',{id:id})
	},
	/**
	 * 添加权限
	 * @param {Object} permsName 权限名称
	 * @param {Object} parentId 上级权限，默认0
	 * @param {Object} orderNum 排序字段
	 * @param {Object} url  默认#
	 * @param {Object} visible 0显示，1停用
	 * @param {Object} perms 权限标识
	 * @param {Object} remarks 备注
	 */
	addPerms(permsName,parentId,orderNum,url,visible,perms,remarks){
		return request.post('/team/sysPermissions/addPerms',{
			permsName:permsName,
			parentId:parentId,
			orderNum:orderNum,
			url:url,
			visible:visible,
			perms:perms,
			remarks:remarks
			})
	},
	/**
	 * 添加权限
	 * @param {Object} permsId id
	 * @param {Object} permsName 权限名称
	 * @param {Object} parentId 上级权限，默认0
	 * @param {Object} orderNum 排序字段
	 * @param {Object} url  默认#
	 * @param {Object} visible 0显示，1停用
	 * @param {Object} perms 权限标识
	 * @param {Object} remarks 备注
	 */
	updatePerms(permsId,permsName,parentId,orderNum,url,visible,perms,remarks){
		return request.post('/team/sysPermissions/updatePerms',{
			permsId:permsId,
			permsName:permsName,
			parentId:parentId,
			orderNum:orderNum,
			url:url,
			visible:visible,
			perms:perms,
			remarks:remarks
		})
	},
	/**
	 * 搜索权限
	 * @param {Object} visible 是否显示
	 * @param {Object} tree 0树形，1普通列表
	 */
	allPerms(visible,tree){
		return request.post('/team/sysPermissions/allPerms',{visible:visible,tree:tree})
	},
	/**
	 * 删除权限 
	 * @param {Object} ids id集合
	 */
	delPerms(ids){
		return request.post('/team/sysPermissions/delPerms',{ids:ids})
	},

	/**
	 * @param {Object} id
	 */
	selPermsById(id){
		return request.post('/team/sysPermissions/selPermsById',{id:id})
	},
	
	/**
	 * 添加角色
	 * @param {Object} roleName 角色名
	 * @param {Object} roleKey 角色key
	 * @param {Object} roleSort 排序
	 * @param {Object} remarks 备注
	 * @param {Object} permIds 权限ids
	 */
	addRole(roleName,roleKey,roleSort,remarks,status,permIds){
		return request.post('/team/sysRole/addRole',{
			roleName:roleName,
			roleKey:roleKey,
			roleSort:roleSort,
			remarks:remarks,
			status:status,
			permIds:permIds
		})
	},
	/**
	 * 更新角色
	 * @param {Object} roleId
	 * @param {Object} roleName
	 * @param {Object} roleKey
	 * @param {Object} roleSort
	 * @param {Object} remarks
	 * @param {Object} status
	 * @param {Object} permIds
	 */
	updateRole(roleId,roleName,roleKey,roleSort,remarks,status,permIds){
		return request.post('/team/sysRole/updateRole',{
			roleId:roleId,
			roleName:roleName,
			roleKey:roleKey,
			roleSort:roleSort,
			remarks:remarks,
			status:0,
			permIds:permIds
		})
	},
	/**
	 * 获取全部角色
	 * @param {Object} status 0正常，1停用
	 */
	selAllRole(status){
		return request.post('/team/sysRole/selAllRole',{status:status})
	},
	
	/**
	 * 根据id查角色
	 * @param {Object} ids
	 */
	selRoleById(ids){
		return request.post('/team/sysRole/selRoleById',{ids:ids})
	},
	
	/**
	 * 删除角色
	 * @param {Object} ids
	 */
	delRole(ids){
		return request.post('/team/sysRole/delRole',{ids:ids})
	},
	
	/**
	 * 添加系统设置
	 * @param {Object} configName imageType1
	 * @param {Object} configKey system.image.type1
	 * @param {Object} configValue jpg
	 * @param {Object} configType
	 * @param {Object} remarks
	 */
	addConfig(configName,configKey,configType,configValue,remarks){
		return request.post('/systemConfig/add',{
			configName:configName,
			configKey:configKey,
			configValue:configValue,
			configType:configType,
			remarks:remarks
		})
	},
	
	/**
	 * 获取配置列表
	 */
	getConfigList(){
		return request.post('/systemConfig/list',{})
	},
	/**
	 * 根据id获取配置
	 * @param {Object} configId
	 */
	getConfigById(configId){
		return request.post('/systemConfig/getById',{configId:configId})
	},
	/**
	 * 编辑配置
	 * @param {Object} configId
	 * @param {Object} configName
	 * @param {Object} configKey
	 * @param {Object} configValue
	 */
	editConfig(configId,configName,configKey,configType,configValue,remarks){
		return request.post('/systemConfig/edit',{
			configId:configId,
			configName:configName,
			configKey:configKey,
			configType:configType,
			configValue:configValue,
			remarks:remarks
		})
	},
	
	/**
	 * 获取访问统计
	 */
	getSysCountNum(){
		return request.post('/sysCount/num',{})
	},
	/**
	 * 获取资源统计
	 */
	getSysCountResource(){
		return request.post('/sysCount/resource',{})
	},
	/**
	 * 修改搜索背景图
	 * @param {Object} file
	 */
	changeSearchBg(file){
		var formData = new FormData();
		formData.append("file", file.file);
		return request.upload('/systemConfig/editBg',formData)
	},
	//以图搜图上传图片
	imgSearchUpload(file){
		var formData = new FormData();
		formData.append("file", file.file);
		return request.upload('/product/imageRetrieval',formData)
	},
	//获取图片标签
	getSearchImgLabels(uuid){
		return request.get('/product/selImageLabels',{selUUID:uuid});
	},
	//下载模版
	downExcelTemplate(ids){
		return request.download('/down/downExcelTemplate',{ids:ids});
	},
	//批量导入产品
	importExcel(file){
		var formData = new FormData();
		formData.append("file", file.file);
		return request.upload('/product/importExcel',formData)
	},
	//获取时间
	getYears(data){
		
		return new Promise((resolve,reject)=>{
			var _list = [];
			
			request.post('/product/getYears',data).then(res=>{
				if(res.code ==0){
					var list = res.years;
					list.forEach(item=>{
						_list.push({
							value:item,
							label:item,
							is_check:false
						})
					})
					return resolve(_list);
				}else{
					return resolve([]);
				}
			}).catch(res=>{
				return resolve([]);
			})
			
			
		})
		
		
	},
	
	//新增或修改部门 deptId deptName orderNum
	editDept(data){
		
		return request.post('/team/sysDept/editDept',data);
	},
	
	//删除部门 ids
	deleteDept(data){
		//ids
		return request.get('/team/sysDept/delDept',data);
	},
	
	//获取所有部门
	selAllDept(){
		return request.get('/team/sysDept/selAllDept',{});
	}
	
}